// extracted by mini-css-extract-plugin
module.exports = {"photoInfo":"PhotoInfo_photoInfo__iX3Fw","description":"PhotoInfo_description__bxc3V","photographer":"PhotoInfo_photographer__pqabG"};